import React from 'react';
import { Checkbox, Table, TableBody, TableCell, TableColumn, TableHeader, TableRow, Tooltip } from '@nextui-org/react';
import { FAMILIES_TABLES_COLS } from '../../../constants/tables';
import { Family, FamilyWithAssignCaregiverData } from '../../../types/families';
import DeleteIcon from '@mui/icons-material/Delete';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { ts2Age } from '../../../helpers/utils';
import theme from '../../theme';
import GroupRemoveRoundedIcon from '@mui/icons-material/GroupRemoveRounded';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

interface IFamiliesTable {
  className?: string;
  data: FamilyWithAssignCaregiverData[],
  onDelete: (family: Family) => void;
  onEdit: (family: Family) => void;
  onCaregiverRemove: (f: Family) => void;
  onWarningToggle: (f_id: string, value: boolean) => void;
}

export default function FamiliesTable({
  className,
  data,
  onEdit,
  onDelete,
  onCaregiverRemove,
  onWarningToggle
}: IFamiliesTable) {

  return (
    <Table
      removeWrapper
      className={className} 
      isStriped aria-label="Famiglie">
      <TableHeader>
        {FAMILIES_TABLES_COLS.map((c, i) => (
          <TableColumn key={i} style={i === 0 ? {width: theme.sizing.x8, textAlign: 'center'} : undefined}>{c}</TableColumn>
        ))}
      </TableHeader>
      <TableBody>
        {
          data.map((family, i) => (
            <TableRow key={i}>
              <TableCell>
                <div style={{justifyContent: 'center', alignItems: 'center'}}>
                {
                  family.warning && (
                    <Tooltip content='Attenzione'>
                      <WarningAmberIcon style={{color: 'orange'}}/>
                    </Tooltip>
                  )
                }
                </div>
                
              </TableCell>
              <TableCell>{family.personalData.surname}</TableCell>
              <TableCell>{family.personalData.name}</TableCell>
              <TableCell>{ts2Age(family.personalData.tsDateOfBirth)}</TableCell>
              <TableCell>{family.personalData.address}</TableCell>
              <TableCell>{family.assignedCaregiverData ? `${family.assignedCaregiverData.name} ${family.assignedCaregiverData.surname}` : 'Nessuna'}</TableCell>
              <TableCell className='max-w-20'>
                <div className="items-center">
                  <Tooltip content="Vedi">
                    <span
                      onClick={() => onEdit(family)} 
                      className="text-lg text-default-400 cursor-pointer active:opacity-50 mr-4">
                      <RemoveRedEyeIcon style={{color: theme.color.primary}}/>
                    </span>
                  </Tooltip>
                  <Tooltip color="danger" content="Rimuovi famiglia">
                    <span
                      onClick={() => onDelete(family)} 
                      className="text-lg text-danger cursor-pointer active:opacity-50 mr-4">
                      <DeleteIcon />
                    </span>
                  </Tooltip>
                  {
                    family.assignedCaregiver && (
                      <Tooltip color="danger" content="Rimuovi badante">
                        <span
                          onClick={() => onCaregiverRemove(family)} 
                          className="text-lg text-danger cursor-pointer active:opacity-50 mr-4">
                          <GroupRemoveRoundedIcon />
                        </span>
                      </Tooltip>
                    )
                  }
                  <Tooltip content="Contrassegna">
                    <span>
                      <Checkbox   
                        isSelected={family.warning ?? false}
                        onValueChange={(v) => onWarningToggle(family.id, v)}/>
                    </span>
                  </Tooltip>
                </div>
              </TableCell>
            </TableRow>
          ))
        }
      </TableBody>
    </Table>
  )
}